import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';

import { AppStore } from 'stores';
import { ProductId } from 'modules/program';

class SearchWidgetController implements Controller {
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "search-widget" */ 'features/search-widget/search-widget.page')
  );

  public pageId = 'SearchWidget';

  public path = '/products/widgets/search-widget';
  public exact = true;

  public routeName = 'search-widget';

  public async fetch({ stores }: FetchOptions): Promise<Result> {
    const appStore = stores?.get<AppStore>('app');
    appStore?.setProductId(ProductId.SearchWidget);
    appStore?.setTracking();
    appStore?.setNetworkFromRouteQuery();

    return {};
  }

  public async fetchPageData(): Promise<PageData> {
    return { title: 'Expedia Group Search Widget' };
  }
}

export { SearchWidgetController };
